// Wired to HeredajoAuth stack outputs. Update when AuthStack is recreated.
export const COGNITO_USER_POOL_ID = "us-east-1_0mmsmLEn0";
export const COGNITO_CLIENT_ID = "2i7urtlsr57lpks0e76mohi9mt";
export const COGNITO_REGION = "us-east-1";
